import '@fountain/ui-kit/components/global-styles';
import 'shared/global-styles';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { onDocumentReady } from 'helpers/dom';
import mountComponents from 'helpers/mount';
import { setup } from 'helpers/ajax';
import notify from '@fountain/ui-kit/components/notifications';
import store from './store';
import Routes from './routes.erb';

import OpeningsDirectoryDsp from './components/openings-directory-dsp/container';
import OpeningsDirectoryIndex from './components/openings-directory-index/container';
import OpeningsDirectoryPicker from './components/openings-directory-picker/container';
import OpeningsDirectoryPreview from './components/openings-directory-preview/container';
import PortalEmailConfirmation from './components/portal-email-confirmation/container';
import PortalPasswordChange from './components/portal-password-change';
import PortalPasswordForgot from './components/portal-password-forgot';
import PortalSignIn from './components/portal-sign-in';
import PortalSignUp from './components/portal-sign-up';

const components = {
  OpeningsDirectoryDsp,
  OpeningsDirectoryIndex,
  OpeningsDirectoryPicker,
  OpeningsDirectoryPreview,
  PortalEmailConfirmation,
  PortalPasswordChange,
  PortalPasswordForgot,
  PortalSignIn,
  PortalSignUp,
};

onDocumentReady(() => {
  // handle page flashes
  if (Array.isArray(window.flashes)) {
    window.flashes.forEach(notification => notify(notification.message, notification.type));
  }

  setup({ signInUrl: Routes.new_identity_session_path() });
  mountComponents(components, () => window.__reactComponentsData__, store);
});
